export const ARCHIVE_NOTIFICATION_RT = "ARCHIVE_NOTIFICATION_RT";

export const UPDATE_NOTIFICATION_RT = "UPDATE_NOTIFICATION_RT";